import { useEffect, useState } from "react";
import { modelStatLimits } from "../../../utils/supplementalData";
import { convertNumberToDecimal, getConformalValue, getStatsCellColor } from "../../../utils/formattingFns";


export default function StatsCell({
    name,
    value,
    statsType,
    isSelected,
    threshold,
}: {
    name: string,
    value: string,
    statsType: 'model' | 'prediction',
    isSelected: boolean,
    threshold?: number,
}) {
    const [ color, setColor ] = useState('#E0E0E0');
    const [ valueLabel, setValueLabel ] = useState('');

    useEffect(() => {
        if (statsType === 'model') {
            const modelLimit = modelStatLimits.find(stat => stat.value === name);
            if (modelLimit) {
                setColor(getStatsCellColor({ min: modelLimit.min, max: modelLimit.max }, Number(value), false));
            } else {
                setColor('#E0E0E0');
            } 
        } else {
            if (threshold !== null && threshold !== undefined && typeof value !== 'number') {
                const numArr = Array.isArray(value) ? value : value.split(',').map(val => Number(val));
                const { color, label } = getConformalValue(numArr, threshold);
                setColor(color);
                setValueLabel(label);
            } else {
                setColor(getStatsCellColor({ min: 0, max: 1 }, Number(value), false));
            }
            
        }
        
    }, [name, value, statsType, threshold]);


    return (
        <td style={{backgroundColor: isSelected ? '#D9DBE7' : color}}>
            <div className="flex justify-center items-center gap-2 py-4 px-6 text-default font-medium">
                {threshold !== null && threshold !== undefined && valueLabel ? (
                    valueLabel
                ) : (
                    convertNumberToDecimal(value)
                )}
            </div>
        </td>
    )
}